<template>
  <div id="captcha"></div>
</template>

<script>
export default {
  mounted() {
    if (!document.getElementById("aliGuide")) {
      // 初始配置
      this.initConfig();
      // 配置script标签
      this.createScriptTag();
    }
  },
  methods: {
    // 显示验证码
    showCaptcha() {
      return new Promise((resolve, reject) => {
        if (window.ic) {
          window.ic.reset();
          return;
        }
        window.ic = new smartCaptcha({
          renderTo: "#captcha",
          width: "100%",
          height: 42,
          default_txt: "请点击按钮开始智能验证",
          success_txt: "验证成功",
          fail_txt: "验证失败，请重试",
          scaning_txt: "智能检测中",
          success: data => {
            let timer = setTimeout(() => {
              clearTimeout(timer);
              this.destroy();
            }, 1000);
            resolve({
              ...data,
              token: NVC_Opt.token,
              flag: "login",
              afs_session_id: data.sessionId
            });
          },
          fail: data => {
            this.$message.error("验证失败，请重试");
            this.destroy();
            reject(data);
          }
        });
        window.ic.init();
      });
    },
    // 初始化配置
    initConfig() {
      window.NVC_Opt = {
        appkey: "FFFF0N0000000000B10E",
        scene: "ic_login",
        renderTo: "#captcha",
        trans: { key1: "code0", nvcCode: 200 },
        elements: [
          "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png",
          "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png"
        ],
        bg_back_prepared:
          "//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png",
        bg_front:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC",
        obj_ok: "//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png",
        bg_back_pass:
          "//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png",
        obj_error: "//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png",
        bg_back_fail:
          "//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png",
        upLang: {
          cn: {
            _ggk_guide: "请摁住鼠标左键，刮出两面盾牌",
            _ggk_success: "恭喜您成功刮出盾牌<br/>继续下一步操作吧",
            _ggk_loading: "加载中",
            _ggk_fail: [
              "呀，盾牌不见了<br/>请",
              "javascript:noCaptcha.reset()",
              "再来一次",
              "或",
              "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
              "反馈问题"
            ],
            _ggk_action_timeout: [
              "我等得太久啦<br/>请",
              "javascript:noCaptcha.reset()",
              "再来一次",
              "或",
              "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
              "反馈问题"
            ],
            _ggk_net_err: [
              "网络实在不给力<br/>请",
              "javascript:noCaptcha.reset()",
              "再来一次",
              "或",
              "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
              "反馈问题"
            ],
            _ggk_too_fast: [
              "您刮得太快啦<br/>请",
              "javascript:noCaptcha.reset()",
              "再来一次",
              "或",
              "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
              "反馈问题"
            ]
          }
        }
      };
    },
    // 创建script标签，必须在定义window.NVC之后，否则会报错undefind
    createScriptTag() {
      let script = document.createElement("script");
      script.src = "//g.alicdn.com/sd/nvc/1.1.112/guide.js";
      script.id = "aliGuide";
      document.body.append(script);
    },
    // 重置
    reset() {
      if (window.ic) {
        window.ic.reset();
        return;
      }
    },
    // 销毁
    destroy() {
      window.ic = null;
      const captchaElement = document.getElementById("captcha");
      if (captchaElement) {
        captchaElement.innerHTML = "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#captcha {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/verify4.vue